export class MaintenanceOffboardingModel {

    private offboardingId!: number;
    private piasRepCode!: string;
    private dateOfResigned!: string;
    private lastDayOfService!: string;
    private dsuCharges!: string;
    private reasonForLeaving!: string;
    private declarationName!: string;
    private declarationDate!: string;
    private offboardingRemarks!: string;
    private clearanceQuestionnaireRemarks1!: string;
    private clearanceQuestionnaireRemarks2!: string;
    private clearanceQuestionnaireRemarks3!: string;
    private clearanceQuestionnaireRemarks4!: string;
    private repStatus!: string;
    private questionFinOutstandingPayment!: boolean;
    private amountFinOutstandingPayment!: string;
    private questionComNegativeBalance!: boolean;
    private amountComNegativeBalance!: string;
    private questionComIndemnityExposure!: boolean;
    private amountComIndemnityExposure!: string;
    private actionComIndemnityExposure!:string;
    private questionBusGiPolicies!: boolean;
    private amountBusGiPolicies!: string;



    getPiasRepCode(): string {
        return this.piasRepCode;
    }

    setPiasRepCode(piasRepCode: string) {
        this.piasRepCode = piasRepCode;
    }

    getoffboardingId(): number {
        return this.offboardingId;
    }

    setoffboardingId(offboardingId: number) {
        this.offboardingId = offboardingId;
    }

    getdateOfResigned(): string {
        return this.dateOfResigned;
    }

    setdateOfResigned(dateOfResigned: string) {
        this.dateOfResigned = dateOfResigned;
    }

    getlastDayOfService(): string {
        return this.lastDayOfService;
    }

    setlastDayOfService(lastDayOfService: string) {
        this.lastDayOfService = lastDayOfService;
    }

    getdsuCharges(): string {
        return this.dsuCharges;
    }

    setdsuCharges(dsuCharges: string) {
        this.dsuCharges = dsuCharges;
    }

    getreasonForLeaving(): string {
        return this.reasonForLeaving;
    }

    setreasonForLeaving(reasonForLeaving: string) {
        this.reasonForLeaving = reasonForLeaving;
    }


    getdeclarationName(): string {
        return this.declarationName;
    }

    setdeclarationName(declarationName: string) {
        this.declarationName = declarationName;
    }

    getdeclarationDate(): string {
        return this.declarationDate;
    }

    setdeclarationDate(declarationDate: string) {
        this.declarationDate = declarationDate;
    }


    getoffboardingRemarks(): string {
        return this.offboardingRemarks;
    }

    setoffboardingRemarks(offboardingRemarks: string) {
        this.offboardingRemarks = offboardingRemarks;
    }


    getClearanceQuestionnaireRemarks1(): string {
        return this.clearanceQuestionnaireRemarks1;
    }

    setClearanceQuestionnaireRemarks1(clearanceQuestionnaireRemarks1: string) {
        this.clearanceQuestionnaireRemarks1 = clearanceQuestionnaireRemarks1;
    }


    getClearanceQuestionnaireRemarks2(): string {
        return this.clearanceQuestionnaireRemarks2;
    }

    setClearanceQuestionnaireRemarks2(clearanceQuestionnaireRemarks2: string) {
        this.clearanceQuestionnaireRemarks2 = clearanceQuestionnaireRemarks2;
    }


    getClearanceQuestionnaireRemarks3(): string {
        return this.clearanceQuestionnaireRemarks3;
    }

    setClearanceQuestionnaireRemarks3(clearanceQuestionnaireRemarks3: string) {
        this.clearanceQuestionnaireRemarks3 = clearanceQuestionnaireRemarks3;
    }


    getClearanceQuestionnaireRemarks4(): string {
        return this.clearanceQuestionnaireRemarks4;
    }

    setClearanceQuestionnaireRemarks4(clearanceQuestionnaireRemarks4: string) {
        this.clearanceQuestionnaireRemarks4 = clearanceQuestionnaireRemarks4;
    }

    getAmountFinOutstandingPayment(): string {
        return this.amountFinOutstandingPayment;
    }

    setAmountFinOutstandingPayment(amountFinOutstandingPayment: string) {
        this.amountFinOutstandingPayment = amountFinOutstandingPayment;
    }

    getAmountComNegativeBalance(): string {
        return this.amountComNegativeBalance;
    }

    setAmountComNegativeBalance(amountComNegativeBalance: string) {
        this.amountComNegativeBalance = amountComNegativeBalance;
    }

    getAmountComIndemnityExposure(): string {
        return this.amountComIndemnityExposure;
    }

    setAmountComIndemnityExposure(amountComIndemnityExposure: string) {
        this.amountComIndemnityExposure = amountComIndemnityExposure;
    }

    getActionComIndemnityExposure(): string {
        return this.actionComIndemnityExposure;
    }

    setActionComIndemnityExposure(actionComIndemnityExposure: string) {
        this.actionComIndemnityExposure = actionComIndemnityExposure;
    }

    getAmountBusGiPolicies(): string {
        return this.amountBusGiPolicies;
    }

    setAmountBusGiPolicies(amountBusGiPolicies: string) {
        this.amountBusGiPolicies = amountBusGiPolicies;
    }

    getQuestionFinOutstandingPayment(): boolean {
        return this.questionFinOutstandingPayment;
    }

    setQuestionFinOutstandingPayment(questionFinOutstandingPayment: boolean) {
        this.questionFinOutstandingPayment = questionFinOutstandingPayment;
    }

    getQuestionComNegativeBalance(): boolean {
        return this.questionComNegativeBalance;
    }

    setQuestionComNegativeBalance(questionComNegativeBalance: boolean) {
        this.questionComNegativeBalance = questionComNegativeBalance;
    }

    getQuestionComIndemnityExposure(): boolean {
        return this.questionComIndemnityExposure;
    }

    setQuestionComIndemnityExposure(questionComIndemnityExposure: boolean) {
        this.questionComIndemnityExposure = questionComIndemnityExposure;
    }

    getQuestionBusGiPolicies(): boolean {
        return this.questionBusGiPolicies;
    }

    setQuestionBusGiPolicies(questionBusGiPolicies: boolean) {
        this.questionBusGiPolicies = questionBusGiPolicies;
    }

    getrepStatus(): string {
        return this.repStatus;
    }

    setrepStatus(repStatus: string) {
        this.repStatus = repStatus;
    }


    toString() {
        return JSON.stringify({
            pias_rep_code: this.getPiasRepCode(),
            off_boarding_details: {
                id: this.getoffboardingId(),
                dateOfResigned: this.getdateOfResigned(),
                lastDayOfService: this.getlastDayOfService(),
                dsuCharges: this.getdsuCharges(),
                reasonForLeaving: this.getreasonForLeaving(),
                remarks: this.getoffboardingRemarks(),
                remarks1: this.getClearanceQuestionnaireRemarks1(),
                remarks2: this.getClearanceQuestionnaireRemarks2(),
                remarks3: this.getClearanceQuestionnaireRemarks3(),
                remarks4: this.getClearanceQuestionnaireRemarks4(),
                questionFinOutstandingPayment:this.getQuestionFinOutstandingPayment(),
                amountFinOutstandingPayment:this.getAmountFinOutstandingPayment(),
                questionComNegativeBalance:this.getQuestionComNegativeBalance(),
                amountComNegativeBalance:this.getAmountComNegativeBalance(),
                questionComIndemnityExposure:this.getQuestionComIndemnityExposure(),
                amountComIndemnityExposure:this.getAmountComIndemnityExposure(),
                actionComIndemnityExposure:this.getActionComIndemnityExposure(),
                questionBusGiPolicies:this.getQuestionBusGiPolicies(),
                amountBusGiPolicies:this.getAmountBusGiPolicies(),
            },
            MnOffBoardingSubmit: {
                mnRepStatus: this.getrepStatus(),
                declarationName: this.getdeclarationName(),
                declarationDate: this.getdeclarationDate(),
            }
        });
    }
}
